module.exports = __webpack_public_path__ + "img/redo-alt.91b6da1d.svg";